// extracted by mini-css-extract-plugin
export default {"content":"AR3UE+R-kR2obGGRiq3TJQ==","illustration":"jb21tH2P4ImBYaxBkVCJRQ=="};